const tpl = (name) => `QUALIFIED_SIGNATURE_APPLICATION/${name}`;

export const INITIALIZE = tpl`INITIALIZE`;
export const INITIALIZE_SUCCESS = tpl`INITIALIZE_SUCCESS`;
export const INITIALIZE_FAILURE = tpl`INITIALIZE_FAILURE`;

export const SUBMIT = tpl`SUBMIT`;
export const SUBMIT_SUCCESS = tpl`SUBMIT_SUCCESS`;
export const SUBMIT_FAILURE = tpl`SUBMIT_FAILURE`;

export const CONFIRM = tpl`CONFIRM`;
export const CONFIRM_SUCCESS = tpl`CONFIRM_SUCCESS`;
export const CONFIRM_FAILURE = tpl`CONFIRM_FAILURE`;

export const RESET = tpl`RESET`;
